// extracted by mini-css-extract-plugin
export var tab = "tabmap-module--tab--H71o8";
export var tab_button = "tabmap-module--tab_button--S6VEX";
export var active = "tabmap-module--active---IoGo";